import React from "react";
import calculateIntegrationDependencies from "src/scenes/overview/overview-components/calculate-integration-dependencies";
import { Stack } from "@mui/material";
import styled from "styled-components";

const InfoText = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 300;
`;
const ZeroAccuracyPlaceholder = ({ dependencies }) => {
    return (
        <Stack direction="column" alignItems="center" spacing={1} mt={6} style={{ width: "100%" }}>
            <InfoText>This feature requires the following integrations:</InfoText>
            {calculateIntegrationDependencies(dependencies)}
        </Stack>
    );
};

export default ZeroAccuracyPlaceholder;
